// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3aPMb","bigColWidth":"Table_bigColWidth__J_7Q9","biggerColWidth":"Table_biggerColWidth__23tn5","row":"Table_row__1uAZ3","col":"Table_col__12ssS"};